<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ $t('performanceAppraisal.performanceAppraisal.formTitle.baseInfo') }}</FormHeader>
    </div>
    <div class="my-form">
      <el-row>
        <el-col :span="8">
          <span class="my-form-label">{{ $t('performanceAppraisal.performanceAppraisal.purchaseUnit') }}</span>
          <span class="my-form-value">{{ value.purchaseUnitName || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="my-form-label">{{ $t('performanceAppraisal.performanceAppraisal.assessSystemName') }}</span>
          <span class="my-form-value">{{ value.assessSystemName || '-' }}</span>
        </el-col>
        <el-col v-if="value.assessSystemNo === '0000'" :span="8">
          <span class="my-form-label">{{ $t('performanceAppraisal.performanceAppraisal.workingPeriod') }}</span>
          <span class="my-form-value">{{ value.workingPeriodName || '-' }}</span>
        </el-col>
        <el-col v-else :span="8">
          <span class="my-form-label">{{ $t('performanceAppraisal.performanceAppraisal.workingPeriodName') }}</span>
          <span class="my-form-value">{{ value.workingPeriodName || '-' }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <span class="my-form-label">{{ label }}</span>
          <span v-if="value.assessSystemNo === '0000'" class="my-form-value">{{ value.examineMonth || '-' }}</span>
          <span v-else class="my-form-value">{{ value.workingDateName || '-' }}</span>
        </el-col>
      </el-row>
    </div>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
export default {
  name: 'MarkBase',
  components: {
    FormHeader
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    itemBinds: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    label() {
      return this.value.assessSystemNo === '0000'
        ? this.$t(`performanceAppraisal.performanceAppraisal.myLabel[${Number(this.value.workingPeriod) - 1}]`)
        : this.$t('performanceAppraisal.performanceAppraisal.workingDateName')
    }
  }
}
</script>

<style lang="scss" scoped>
.my-form {
  padding-left: 8px;
  font-size: 12px;
  font-family: "Microsoft YaHei", serif;
  .my-form-label {
    width: 55px;
    height: 17px;
    font-weight: 400;
    color: #666666;
  }
  .my-form-value {
    margin-left: 12px;
    height: 17px;
    font-weight: 500;
    color: #333333;
  }
}
</style>
